import type React from 'react';

import { Link } from 'react-router';
import type { BrainAtlasType, MultiLang } from '../config';

interface Props {
    lang: MultiLang;
    type: BrainAtlasType;
    isLink: boolean;
}

const Footer: React.FC<Props> = (props) => {
    const { type, isLink } = props;
    return (
        <footer>
            <div className="links clearfix">
                <span className={`image ${type}`}>&nbsp;</span>
                {!isLink && (
                    <Link className="relatedLink" to={`/${type}_html/link.html`}>
                        <span>Related Link</span>
                    </Link>
                )}
                <a className="bsi-ni" href="https://bsi-ni.brain.riken.jp/" target="_blank" rel="noopener noreferrer">
                    <span>BSI-Neuroinformatics</span>
                </a>
                <span className="gotoTop">
                    <Link to="/">&raquo; GO TO TOP</Link>
                </span>
            </div>
            {type === 'marmoset' ? (
                <div className="copyright">
                    Copyright (C) 2018 Laboratory for Symbolic Cognitive Development, RIKEN Center for Biosystems
                    Dynamics Research.
                </div>
            ) : (
                <div className="copyright">
                    Copyright (C) 2017 BSI-NI Project &amp; Laboratory for Symbolic Cognitive Development, RIKEN Brain
                    Science Insititute.
                </div>
            )}
        </footer>
    );
};

export default Footer;
